/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

export enum MassActionType {
    Create = 'create',
    Delete = 'delete',
    ChangeStatus = 'change_status',
    ChangePotential = 'change_category',
    ChangeIndustry = 'change_industry',
    ChangeAccountType = 'change_account_type',
    AssignSeller = 'assign_seller',
    AssignCompany = 'assign_company',
    AddTags = 'add_tags',
    RemoveTags = 'remove_tags',
    AddNote = 'add_note',
    AddReminder = 'add_reminder',
    Export = 'export',
}
